import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { MCButton, MCText, View } from 'src/components/basic';
import { remCss } from 'src/components/mobile/utils';
import { addressObject, userFullName } from 'src/helpers';
import { BASE_ICONS } from 'src/components/svg';
import LANG_CONST from 'src/helpers/lang/const';
import { StaticGoogleMap } from 'src/components/location/GoogleMaps';
import { workingTimes } from '../utils';

export const SubLocation = ({ clinic, manager, onChatSupport, location, emptyManagers }) => {
  return (
    <View style={{ gap: remCss(20) }}>
      <MCText
        size={25}
        weight={500}
        heading
        label={
          userFullName(clinic) +
          (location
            ? ' - ' +
              addressObject({
                countryAddress: location.country,
                cityAddress: location.city,
                stateAddress: location.state
              }).shortAddressNameReverse
            : '')
        }
      />
      <View style={{ flexDirection: 'row', gap: remCss(10) }}>
        <MCButton iconname={BASE_ICONS.PHONE_FILL} width={25} primary light radius padding={1} />
        <MCText
          size={18}
          weight={400}
          lineHeight={25}
          textLight
          label={formatPhoneNumberIntl((clinic.phoneNumber || '').toString())}
        />
      </View>
      <View style={{ flexDirection: 'row', gap: remCss(10) }}>
        <MCButton iconname={BASE_ICONS.EMAIL} width={25} primary light radius padding={1} />
        <MCText size={18} weight={400} lineHeight={25} textLight label={clinic.email} />
      </View>
      {onChatSupport && !emptyManagers && (
        <MCButton
          label={LANG_CONST.buttons.chat_support}
          largeMedium
          primary
          dark
          style={{ maxWidth: remCss(380) }}
          radius
          onClick={(e) => {
            e.preventDefault();
            onChatSupport(manager);
            e.stopPropagation();
          }}
        />
      )}
      {location && (
        <View style={{ flexDirection: 'row', gap: remCss(10) }}>
          <MCButton iconname={BASE_ICONS.LOCATION} width={25} primary light radius padding={1} />
          <MCText
            size={18}
            weight={400}
            lineHeight={25}
            textLight
            label={location.hospital?.split('_')[0]}
          />
        </View>
      )}
      <View style={{ flexDirection: 'row', gap: remCss(10) }}>
        <MCButton iconname={BASE_ICONS.CLOCK} width={25} primary light radius padding={8} />
        <View>
          {workingTimes(!location?.schedule ? null : location?.schedule).map((item, i) => (
            <MCText label={item.day + ': ' + item.time} size={18} weight={400} textLight key={i} />
          ))}
        </View>
      </View>
      {location && (
        <View style={{ maxWidth: remCss(380) }}>
          <StaticGoogleMap lat={location.location.latitude} lng={location.location.longitude} />
        </View>
      )}
    </View>
  );
};
